/* eslint-disable */
import React from 'react';

const Callstatic = ({ filled }) => (
    <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill=""
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.58099 0.416761C9.58099 0.186709 9.7677 0 9.99775 0C15.5127 0 20 4.48727 20 10.0023C20 10.2323 19.8133 10.419 19.5833 10.419C19.3532 10.419 19.1665 10.2323
              19.1665 10.0023C19.1665 4.94654 15.0535 0.833522 9.99775 0.833522C9.7677 0.833522 9.58099 0.646813 9.58099 0.416761ZM12.8344 12.8547C13.3908 12.8547 13.9143 13.0715
              14.3077 13.4649L16.076 15.2332C16.8883 16.0459 16.8883 17.3679 16.076 18.1801L15.1058 19.1499C14.5561 19.7 13.8242 20.0026 13.0449 20.0026C12.471 20.0026 11.9146
              19.8355 11.4354 19.5188C7.12189 16.6652 3.33436 12.8777 0.481631 8.56544C-0.279792 7.4131 -0.124757 5.869 0.850047 4.8942L1.82027 3.92398C2.21411 3.53055 2.73714
              3.31384 3.29393 3.31384C3.85031 3.31384 4.37376 3.53055 4.76719 3.92398L6.5355 5.69229C7.34777 6.50456 7.34777 7.82694 6.5355 8.63921L6.2146 8.96012C7.65701
              10.6843 9.31405 12.3413 11.0399 13.7858L11.3608 13.4649C11.7546 13.0715 12.2776 12.8547 12.8344 12.8547ZM9.99775 4.1673C13.2151 4.1673 15.8324 6.78456 15.8324
              10.002C15.8324 10.232 16.0191 10.4187 16.2492 10.4187C16.4792 10.4187 16.6659 10.232 16.6659 10.002C16.6659 6.32529 13.6744 3.33378 9.99775 3.33378C9.76769 3.33378
              9.58099 3.52049 9.58099 3.75054C9.58099 3.98101 9.76769 4.1673 9.99775 4.1673ZM12.4983 10.0025C12.4983 8.62339 11.3768 7.50189 9.99775 7.50189C9.7677 7.50189
              9.58099 7.3156 9.58099 7.08513C9.58099 6.85507 9.7677 6.66837 9.99775 6.66837C11.8361 6.66837 13.3318 8.16412 13.3318 10.0025C13.3318 10.2325 13.1451 10.4192 12.9151
              10.4192C12.685 10.4192 12.4983 10.2325 12.4983 10.0025Z"
            fill={filled ? '#05C3DE' : 'white'}
        />
        <mask
            id="mask0"
            masktype="alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="20"
            height="21"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.58099 0.416761C9.58099 0.186709 9.7677 0 9.99775 0C15.5127 0 20 4.48727 20 10.0023C20 10.2323 19.8133 10.419 19.5833 10.419C19.3532 10.419 19.1665 10.2323
                  19.1665 10.0023C19.1665 4.94654 15.0535 0.833522 9.99775 0.833522C9.7677 0.833522 9.58099 0.646813 9.58099 0.416761ZM12.8344 12.8547C13.3908 12.8547 13.9143
                  13.0715 14.3077 13.4649L16.076 15.2332C16.8883 16.0459 16.8883 17.3679 16.076 18.1801L15.1058 19.1499C14.5561 19.7 13.8242 20.0026 13.0449 20.0026C12.471
                  20.0026 11.9146 19.8355 11.4354 19.5188C7.12189 16.6652 3.33436 12.8777 0.481631 8.56544C-0.279792 7.4131 -0.124757 5.869 0.850047 4.8942L1.82027
                  3.92398C2.21411 3.53055 2.73714 3.31384 3.29393 3.31384C3.85031 3.31384 4.37376 3.53055 4.76719 3.92398L6.5355 5.69229C7.34777 6.50456 7.34777 7.82694 6.5355
                  8.63921L6.2146 8.96012C7.65701 10.6843 9.31405 12.3413 11.0399 13.7858L11.3608 13.4649C11.7546 13.0715 12.2776 12.8547 12.8344 12.8547ZM9.99775 4.1673C13.2151
                  4.1673 15.8324 6.78456 15.8324 10.002C15.8324 10.232 16.0191 10.4187 16.2492 10.4187C16.4792 10.4187 16.6659 10.232 16.6659 10.002C16.6659 6.32529 13.6744
                  3.33378 9.99775 3.33378C9.76769 3.33378 9.58099 3.52049 9.58099 3.75054C9.58099 3.98101 9.76769 4.1673 9.99775 4.1673ZM12.4983 10.0025C12.4983 8.62339 11.3768
                  7.50189 9.99775 7.50189C9.7677 7.50189 9.58099 7.3156 9.58099 7.08513C9.58099 6.85507 9.7677 6.66837 9.99775 6.66837C11.8361 6.66837 13.3318 8.16412 13.3318
                  10.0025C13.3318 10.2325 13.1451 10.4192 12.9151 10.4192C12.685 10.4192 12.4983 10.2325 12.4983 10.0025Z"
                fill={filled ? '#05C3DE' : 'white'}
            />
        </mask>
        <g mask="url(#mask0)" />
    </svg>
);

export default Callstatic;
